(() => {
  if (window.__MF_TRUCKER_DESIGNER_V2_MULTI__) return;
  window.__MF_TRUCKER_DESIGNER_V2_MULTI__ = true;

  const OUTPUT_W = 1181;
  const OUTPUT_H = 591;
  const MM_W = 100;
  const MM_H = 50;
  const SAFE_X = 0.04;
  const SAFE_Y = 0.08;
  const clamp = (v,min,max) => Math.min(max,Math.max(min,v));
  const normAngle = d => {
    while (d > Math.PI) d -= Math.PI * 2;
    while (d < -Math.PI) d += Math.PI * 2;
    return d;
  };

  function init(shell){
    if(!shell || shell.dataset.mfTruckerReadyMulti === '1') return;
    shell.dataset.mfTruckerReadyMulti = '1';

    const q = s => shell.querySelector(s);
    const openBtn = q('[data-mf-trucker-open]');
    const dialog = q('[data-mf-trucker-dialog]');
    const closeBtn = q('[data-mf-trucker-close]');
    const canvas = q('[data-mf-trucker-canvas]');
    const previewCanvas = q('[data-mf-trucker-preview-canvas]');
    const previewImage = q('[data-mf-trucker-preview-image]');
    const fileInput = q('[data-mf-trucker-file]');
    const fileName = q('[data-mf-trucker-file-name]');
    const textInput = q('[data-mf-trucker-text]');
    const fontSelect = q('[data-mf-trucker-font]');
    const colorInput = q('[data-mf-trucker-text-color]');
    const imageScaleInput = q('[data-mf-trucker-image-scale]');
    const textSizeInput = q('[data-mf-trucker-text-size]');
    const layersWrap = q('.mf-trucker-layers');
    const colorButtons = Array.from(shell.querySelectorAll('[data-mf-trucker-color-choice]'));
    const colorLabel = q('[data-mf-trucker-color-label]');
    const fitBtn = q('[data-mf-trucker-fit]');
    const centerBtn = q('[data-mf-trucker-center]');
    const resetBtn = q('[data-mf-trucker-reset]');
    const cartBtn = q('[data-mf-trucker-cart]');
    const status = q('[data-mf-trucker-status]');
    const hint = q('.mf-trucker-hint');

    if(!canvas || !previewCanvas) return;

    const ctx = canvas.getContext('2d', { alpha:true, desynchronized:true });
    const pctx = previewCanvas.getContext('2d', { alpha:true, desynchronized:true });
    canvas.width = previewCanvas.width = OUTPUT_W;
    canvas.height = previewCanvas.height = OUTPUT_H;

    if(fileInput){
      fileInput.multiple = true;
      fileInput.setAttribute('multiple','multiple');
    }
    const uploadLabel = fileInput?.closest('label')?.querySelector('span');
    if(uploadLabel) uploadLabel.textContent = 'Motive hochladen';
    const motifHeading = fileInput?.closest('.mf-trucker-panel')?.querySelector('.mf-trucker-panel__heading strong');
    if(motifHeading) motifHeading.textContent = 'Deine Motive';
    if(hint) hint.textContent = 'Mehrere Motive können unabhängig ausgewählt, verschoben, skaliert und gedreht werden. Mit einem Finger verschieben, mit zwei Fingern zoomen und drehen.';

    const state = {
      selected: null,
      images: [],
      text: '', textX:.5, textY:.5, textSize:.17, textColor:'#ffffff', font:'Arial',
      capColor:'Schwarz', dragging:false, pointerId:null, lastX:0, lastY:0
    };
    const pointers = new Map();
    let gesture = null;
    let seq = 0;

    const keyFor = item => `image:${item.id}`;
    const selectedImage = () => {
      if(!String(state.selected || '').startsWith('image:')) return null;
      const id = String(state.selected).slice(6);
      return state.images.find(x => x.id === id) || null;
    };

    const setStatus = (msg,type='') => {
      if(status){ status.textContent = msg || ''; status.dataset.type = type; }
    };

    function imageSize(item){
      if(!item?.img) return {w:0,h:0};
      const fit = Math.min(OUTPUT_W/item.img.naturalWidth, OUTPUT_H/item.img.naturalHeight);
      return { w:item.img.naturalWidth*fit*item.scale, h:item.img.naturalHeight*fit*item.scale };
    }

    function syncScale(){
      const item = selectedImage();
      if(imageScaleInput && item) imageScaleInput.value = String(Math.round(item.scale*100));
    }

    function rebuildLayers(){
      if(!layersWrap) return;
      layersWrap.innerHTML = '';
      state.images.forEach((item,i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.dataset.mfTruckerLayerKey = keyFor(item);
        b.textContent = `Motiv ${i+1}`;
        b.title = item.file?.name || `Motiv ${i+1}`;
        const on = state.selected === keyFor(item);
        b.classList.toggle('is-active',on);
        b.setAttribute('aria-pressed',on?'true':'false');
        b.addEventListener('click',() => { cancel(); setLayer(keyFor(item)); });
        layersWrap.appendChild(b);
      });
      const tb = document.createElement('button');
      tb.type = 'button';
      tb.dataset.mfTruckerLayerKey = 'text';
      tb.textContent = 'Text';
      const ton = state.selected === 'text';
      tb.classList.toggle('is-active',ton);
      tb.setAttribute('aria-pressed',ton?'true':'false');
      tb.addEventListener('click',() => { cancel(); setLayer('text'); });
      layersWrap.appendChild(tb);
    }

    let deleteBtn = q('[data-mf-trucker-delete-layer]');
    if(!deleteBtn && layersWrap){
      deleteBtn = document.createElement('button');
      deleteBtn.type = 'button';
      deleteBtn.className = 'mf-trucker-reset';
      deleteBtn.dataset.mfTruckerDeleteLayer = '';
      deleteBtn.textContent = 'Ausgewählte Ebene löschen';
      deleteBtn.style.marginTop = '8px';
      layersWrap.insertAdjacentElement('afterend',deleteBtn);
    }

    function setLayer(key){
      state.selected = key;
      rebuildLayers();
      syncScale();
      render();
    }

    function drawDesign(target,selection=false){
      target.clearRect(0,0,OUTPUT_W,OUTPUT_H);
      if(selection){
        target.save();
        target.lineWidth = 2;
        target.strokeStyle = 'rgba(255,255,255,.18)';
        for(let i=1;i<10;i++){ const x=OUTPUT_W*i/10; target.beginPath(); target.moveTo(x,0); target.lineTo(x,OUTPUT_H); target.stroke(); }
        for(let i=1;i<5;i++){ const y=OUTPUT_H*i/5; target.beginPath(); target.moveTo(0,y); target.lineTo(OUTPUT_W,y); target.stroke(); }
        target.strokeStyle='rgba(245,130,32,.95)'; target.lineWidth=4; target.setLineDash([16,12]);
        target.strokeRect(OUTPUT_W*SAFE_X,OUTPUT_H*SAFE_Y,OUTPUT_W*(1-SAFE_X*2),OUTPUT_H*(1-SAFE_Y*2));
        target.restore();
      }

      state.images.forEach(item => {
        const {w,h} = imageSize(item), cx=item.x*OUTPUT_W, cy=item.y*OUTPUT_H;
        target.save();
        target.translate(cx,cy);
        target.rotate(item.rotation);
        target.drawImage(item.img,-w/2,-h/2,w,h);
        if(selection && state.selected === keyFor(item)){
          target.strokeStyle='#f58220'; target.lineWidth=7; target.setLineDash([20,14]); target.strokeRect(-w/2,-h/2,w,h);
        }
        target.restore();
      });

      if(state.text){
        const size=Math.max(24,Math.round(OUTPUT_H*state.textSize));
        const maxW=OUTPUT_W*.92;
        target.save(); target.font=`800 ${size}px ${state.font}`; target.textAlign='center'; target.textBaseline='middle'; target.fillStyle=state.textColor; target.lineJoin='round';
        target.fillText(state.text,state.textX*OUTPUT_W,state.textY*OUTPUT_H,maxW);
        if(selection && state.selected==='text'){
          const m=target.measureText(state.text), bw=Math.min(maxW,m.width+36), bh=size*1.3;
          target.strokeStyle='#f58220'; target.lineWidth=7; target.setLineDash([20,14]);
          target.strokeRect(state.textX*OUTPUT_W-bw/2,state.textY*OUTPUT_H-bh/2,bw,bh);
        }
        target.restore();
      }
    }

    function render(){ drawDesign(ctx,true); drawDesign(pctx,false); }

    function cancel(){ pointers.clear(); gesture=null; state.dragging=false; state.pointerId=null; }

    function selectCapColor(button){
      if(!button) return;
      state.capColor = button.dataset.mfTruckerColorChoice || 'Schwarz';
      const src = button.dataset.mfTruckerColorImage || '';
      if(previewImage && src){ previewImage.src=src; previewImage.alt=`Trucker Cap ${state.capColor} ohne Aufdruck`; }
      if(colorLabel) colorLabel.textContent=state.capColor;
      colorButtons.forEach(b=>{ const on=b===button; b.classList.toggle('is-active',on); b.setAttribute('aria-pressed',on?'true':'false'); });
    }
    const defaultColor = () => colorButtons.find(b=>b.dataset.mfTruckerColorChoice==='Schwarz') || colorButtons[0];

    function updateFilename(){
      if(!fileName) return;
      if(!state.images.length) fileName.textContent='Noch keine Datei ausgewählt';
      else if(state.images.length===1) fileName.textContent=state.images[0].file?.name || '1 Motiv geladen';
      else fileName.textContent=`${state.images.length} Motive geladen`;
    }

    function reset(){
      cancel();
      state.images = [];
      Object.assign(state,{selected:null,text:'',textX:.5,textY:.5,textSize:.17,textColor:'#ffffff',font:'Arial'});
      if(fileInput) fileInput.value='';
      if(textInput) textInput.value='';
      if(fontSelect) fontSelect.value='Arial';
      if(colorInput) colorInput.value='#ffffff';
      if(imageScaleInput) imageScaleInput.value='100';
      if(textSizeInput) textSizeInput.value='17';
      updateFilename(); selectCapColor(defaultColor()); rebuildLayers(); setStatus(''); render();
    }

    function loadFile(file,index=0){
      if(!file || !String(file.type||'').startsWith('image/')){ setStatus('Bitte wähle eine Bilddatei aus.','error'); return; }
      const url=URL.createObjectURL(file), img=new Image();
      img.onload=()=>{
        URL.revokeObjectURL(url);
        const item={ id:`${Date.now().toString(36)}-${++seq}`, img, file, x:clamp(.5+index*.025,SAFE_X,1-SAFE_X), y:clamp(.5+index*.025,SAFE_Y,1-SAFE_Y), scale:1, rotation:0 };
        state.images.push(item);
        updateFilename(); setLayer(keyFor(item)); setStatus(`${state.images.length} Motiv${state.images.length===1?'':'e'} geladen.`,'success'); render();
      };
      img.onerror=()=>{ URL.revokeObjectURL(url); setStatus('Ein Bild konnte nicht geladen werden.','error'); };
      img.src=url;
    }

    function point(e){ const r=canvas.getBoundingClientRect(); return {x:(e.clientX-r.left)/r.width,y:(e.clientY-r.top)/r.height}; }
    function metrics(){ const a=Array.from(pointers.values()).slice(0,2); if(a.length<2)return null; return {distance:Math.hypot(a[1].x-a[0].x,a[1].y-a[0].y),angle:Math.atan2(a[1].y-a[0].y,a[1].x-a[0].x)}; }
    function startGesture(){ const m=metrics(); gesture=m?{lastDistance:Math.max(m.distance,.0001),lastAngle:m.angle}:null; state.dragging=false; state.pointerId=null; }
    function resumeDrag(){ if(pointers.size!==1){state.dragging=false;state.pointerId=null;return;} const [id,p]=pointers.entries().next().value; state.dragging=true; state.pointerId=id; state.lastX=p.x; state.lastY=p.y; }

    function down(e){
      const img=selectedImage();
      if(state.selected==='text' && !state.text) return;
      if(String(state.selected||'').startsWith('image:') && !img) return;
      if(!state.selected) return;
      const p=point(e); pointers.set(e.pointerId,p); canvas.setPointerCapture?.(e.pointerId);
      if(img && pointers.size>=2) startGesture();
      else if(pointers.size===1){ state.dragging=true; state.pointerId=e.pointerId; state.lastX=p.x; state.lastY=p.y; }
      e.preventDefault();
    }

    function move(e){
      if(!pointers.has(e.pointerId)) return;
      const p=point(e); pointers.set(e.pointerId,p);
      const img=selectedImage();
      if(img && pointers.size>=2){
        if(!gesture) startGesture();
        const m=metrics(); if(!m||!gesture)return;
        img.scale=clamp(img.scale*(m.distance/gesture.lastDistance),.15,3);
        img.rotation+=normAngle(m.angle-gesture.lastAngle);
        gesture.lastDistance=Math.max(m.distance,.0001); gesture.lastAngle=m.angle;
        if(imageScaleInput) imageScaleInput.value=String(Math.round(img.scale*100));
        render(); e.preventDefault(); return;
      }
      if(!state.dragging||e.pointerId!==state.pointerId) return;
      const dx=p.x-state.lastX, dy=p.y-state.lastY;
      if(img){ img.x=clamp(img.x+dx,SAFE_X,1-SAFE_X); img.y=clamp(img.y+dy,SAFE_Y,1-SAFE_Y); }
      else if(state.selected==='text'){ state.textX=clamp(state.textX+dx,SAFE_X,1-SAFE_X); state.textY=clamp(state.textY+dy,SAFE_Y,1-SAFE_Y); }
      state.lastX=p.x; state.lastY=p.y; render(); e.preventDefault();
    }

    function up(e){
      if(!pointers.has(e.pointerId)) return;
      pointers.delete(e.pointerId); try{canvas.releasePointerCapture?.(e.pointerId);}catch(_){}
      if(selectedImage() && pointers.size>=2) startGesture(); else { gesture=null; resumeDrag(); }
      e.preventDefault();
    }

    function cleanCanvas(){ const c=document.createElement('canvas'); c.width=OUTPUT_W; c.height=OUTPUT_H; drawDesign(c.getContext('2d'),false); return c; }
    const canvasFile=(c,name)=>new Promise((res,rej)=>c.toBlob(blob=>blob?res(new File([blob],name,{type:'image/png'})):rej(new Error('PNG-Datei konnte nicht erzeugt werden.')),'image/png'));
    function variantId(){ const inputs=Array.from(document.querySelectorAll('form[action*="/cart/add"] [name="id"]')); const live=inputs.find(i=>/^\d+$/.test(String(i.value||''))); if(live)return Number(live.value); const f=shell.dataset.mfVariantId; return /^\d+$/.test(String(f||''))?Number(f):null; }
    function qty(){ const i=document.querySelector('form[action*="/cart/add"] [name="quantity"]'); const v=Number(i?.value||1); return Number.isFinite(v)&&v>0?Math.floor(v):1; }

    async function addToCart(){
      if(!state.images.length && !state.text.trim()){ setStatus('Bitte lade mindestens ein Motiv hoch oder gib einen Text ein.','error'); return; }
      const id=variantId(); if(!id){ setStatus('Die Produktvariante konnte nicht gefunden werden.','error'); return; }
      const old=cartBtn?.textContent||'PERSONALISIERT IN DEN WARENKORB';
      if(cartBtn){cartBtn.disabled=true;cartBtn.textContent='DESIGN WIRD GESPEICHERT …';}
      setStatus('Dein Design wird gespeichert …');
      try{
        const designId=window.crypto?.randomUUID?.()||`mf-trucker-${Date.now()}-${Math.random().toString(16).slice(2)}`;
        const print=await canvasFile(cleanCanvas(),`MF-${designId}-TruckerCap-100x50mm.png`);
        const json={
          version:'mf-trucker-designer-v2-multimotiv', designId, product:'Trucker Cap', capColor:state.capColor,
          printAreaMm:{width:MM_W,height:MM_H}, outputPx:{width:OUTPUT_W,height:OUTPUT_H,dpi:300}, savedAt:new Date().toISOString(),
          images:state.images.map((item,i)=>({index:i+1,name:item.file?.name,size:item.file?.size,type:item.file?.type,x:item.x,y:item.y,scale:item.scale,rotationDeg:item.rotation*180/Math.PI})),
          text:state.text?{value:state.text,x:state.textX,y:state.textY,size:state.textSize,color:state.textColor,font:state.font}:null
        };
        const dataFile=new File([JSON.stringify(json,null,2)],`MF-${designId}-TruckerCap-Designdaten.json`,{type:'application/json'});
        const fd=new FormData();
        fd.append('id',String(id)); fd.append('quantity',String(qty())); fd.append('properties[Personalisierung]','Trucker-Cap-Designer'); fd.append('properties[Trucker-Farbe]',state.capColor);
        fd.append('properties[_MF Designer]','trucker-v2-multimotiv'); fd.append('properties[_MF Design-ID]',designId); fd.append('properties[_MF Druckfläche]','100 × 50 mm'); fd.append('properties[_MF Druckdatei]',print,print.name); fd.append('properties[_MF Design-Daten]',dataFile,dataFile.name);
        state.images.forEach((item,i)=>fd.append(`properties[_MF Kundenmotiv ${i+1}]`,item.file,item.file?.name||`Kundenmotiv-${i+1}`));
        if(state.images[0]?.file) fd.append('properties[_MF Kundenfoto]',state.images[0].file,state.images[0].file.name||'Kundenmotiv');
        fd.append('properties[Anzahl Motive]',String(state.images.length));
        if(state.text.trim()) fd.append('properties[Wunschtext]',state.text.trim());
        const root=window.Shopify?.routes?.root||'/';
        const r=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:fd});
        const result=await r.json().catch(()=>({})); if(!r.ok) throw new Error(result?.description||result?.message||`Shopify-Fehler ${r.status}`);
        setStatus('Trucker Cap wurde personalisiert in den Warenkorb gelegt.','success'); if(cartBtn)cartBtn.textContent='IM WARENKORB ✓'; setTimeout(()=>window.location.assign(root+'cart'),300);
      }catch(err){ console.error('[MF Trucker-Designer]',err); setStatus(String(err?.message||err||'Beim Speichern ist ein Fehler aufgetreten.'),'error'); if(cartBtn){cartBtn.disabled=false;cartBtn.textContent=old;} }
    }

    openBtn?.addEventListener('click',()=>dialog?.showModal?.());
    closeBtn?.addEventListener('click',()=>{cancel();dialog?.close?.();});
    dialog?.addEventListener('click',e=>{if(e.target===dialog){cancel();dialog.close?.();}});
    fileInput?.addEventListener('change',()=>{
      const files=Array.from(fileInput.files||[]);
      files.forEach((f,i)=>loadFile(f,i));
      fileInput.value='';
    });
    textInput?.addEventListener('input',()=>{ state.text=String(textInput.value||'').slice(0,80); if(state.text)setLayer('text'); else render(); });
    fontSelect?.addEventListener('change',()=>{state.font=fontSelect.value||'Arial';render();});
    colorInput?.addEventListener('input',()=>{state.textColor=colorInput.value||'#ffffff';render();});
    imageScaleInput?.addEventListener('input',()=>{const img=selectedImage();if(!img)return;img.scale=clamp(Number(imageScaleInput.value||100)/100,.15,3);render();});
    textSizeInput?.addEventListener('input',()=>{state.textSize=Math.max(.06,Number(textSizeInput.value||17)/100);setLayer('text');render();});
    colorButtons.forEach(b=>b.addEventListener('click',()=>selectCapColor(b)));
    fitBtn?.addEventListener('click',()=>{cancel();const img=selectedImage();if(img){Object.assign(img,{x:.5,y:.5,scale:1,rotation:0});if(imageScaleInput)imageScaleInput.value='100';}render();});
    centerBtn?.addEventListener('click',()=>{const img=selectedImage();if(img){img.x=.5;img.y=.5;}else if(state.selected==='text'){state.textX=.5;state.textY=.5;}render();});
    deleteBtn?.addEventListener('click',()=>{
      cancel();
      const img=selectedImage();
      if(img){ state.images=state.images.filter(x=>x!==img); state.selected=state.images.at(-1)?keyFor(state.images.at(-1)):(state.text?'text':null); updateFilename(); }
      else if(state.selected==='text'){ state.text=''; if(textInput)textInput.value=''; state.selected=state.images.at(-1)?keyFor(state.images.at(-1)):null; }
      rebuildLayers(); syncScale(); render();
    });
    resetBtn?.addEventListener('click',reset);
    cartBtn?.addEventListener('click',addToCart);
    canvas.addEventListener('pointerdown',down); canvas.addEventListener('pointermove',move); canvas.addEventListener('pointerup',up); canvas.addEventListener('pointercancel',up);
    canvas.addEventListener('wheel',e=>{const img=selectedImage();if(!img)return;e.preventDefault();img.scale=clamp(img.scale+(e.deltaY>0?-.05:.05),.15,3);if(imageScaleInput)imageScaleInput.value=String(Math.round(img.scale*100));render();},{passive:false});

    selectCapColor(defaultColor());
    rebuildLayers();
    render();
  }

  const boot=()=>document.querySelectorAll('[data-mf-trucker-shell]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
